import React, { useEffect, useMemo } from 'react';
import Field from '../../shared/ui/Field';
import { useFieldController } from '../../../../helpers/formManager';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import DropdownSelectControl from '../../shared/ui/DropdownSelectControl';
import { declOfNum } from '../../../../helpers/dspx-utils';
import { useValueRef } from '../../../../hooks/useValueRef';

const defaultValue = { key: 0, label: 'Все' };

const allOption = {
  key: 0,
  content: 'Все',
  value: defaultValue,
  search: 'Все',
};

const createFieldName = fieldPathBuilders.deskScheduleSetting.intervalsPerDay;

const SelectIntervalsPerDay = ({
  deskIndex,
  entityKey,
  intervalCount,
  disabled,
}) => {
  // const options = useMemo(() => createOptions(intervalCount), [intervalCount]);

  const {
    field: { value, onChange },
  } = useFieldController({
    name: createFieldName(deskIndex, entityKey),
    defaultValue,
  });

  // Будет внедрено позже
  // const controlContent = value?.label;
  // const renderControl = useMemo(
  //   () => getRenderControl(controlContent),
  //   [controlContent]
  // );

  // const valuesRef = useValueRef({ value, onChange });

  // useEffect(() => {
  //   const { value, onChange } = valuesRef.current;

  //   const isNotAllValue = value?.key !== allOption.value.key;
  //   const isIntervalsNoneOrLess = !intervalCount || intervalCount <= value.key;

  //   if (isNotAllValue && isIntervalsNoneOrLess) {
  //     onChange(allOption.value);
  //   }
  // }, [intervalCount, valuesRef]);

  return null;

  // return (
  //   <Field.Memoized
  //     type={Field.types.dropdownSelect}
  //     value={value}
  //     onChange={onChange}
  //     options={options}
  //     formItemLabel="Производительность стола"
  //     renderControl={renderControl}
  //     disabled={disabled}
  //   />
  // );
};

SelectIntervalsPerDay.default = defaultValue;

export default SelectIntervalsPerDay;

function getRenderControl(content) {
  return (props) => {
    const { visible, loading, disabled, className, ...rest } = props;

    return (
      <DropdownSelectControl
        {...rest}
        visible={visible}
        loading={loading}
        disabled={disabled}
      >
        {content || 'Выбрать из списка'}
      </DropdownSelectControl>
    );
  };
}

function createOptions(count) {
  const options = Array.from({ length: count ? count - 1 : count }, (_, i) => {
    const n = i + 1;
    const label = `${n} ${declOfNum(n, [
      'интервал',
      'интервала',
      'интервалов',
    ])} в день`;

    return {
      key: n,
      value: { key: n, label },
      content: label,
      search: label,
    };
  });

  return [allOption, ...options];
}
